import React, { useState, useEffect } from 'react';
import { DillModal } from '../Dill/DillModal';
import { DillButton } from '../Dill/DillButton';
import { AppInputField } from '../AppInputField/AppInputField';

export const AppSubmitEmailModal = ({
  open,
  handleClose,
  onSubmit,
  title,
  value,
}: {
  open: boolean;
  handleClose: () => void;
  onSubmit: (val: string) => void;
  title: string;
  value?: string;
}) => {
  const [textFieldValue, setTextFieldValue] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (value) {
      setTextFieldValue(value);
    }
  }, [value]);

  const handleCloseModal = () => {
    setTextFieldValue('');
    handleClose();
  };

  const handleSubmit = () => {
    if (!textFieldValue) {
      setError('Email is required');
      return;
    }
    const emailRegex = /[\w.+-]+@[\w-]+\.[a-z]{1,}/gi;
    if (!emailRegex.test(textFieldValue.trim())) {
      setError('Email is not valid');
      return;
    }
    onSubmit(textFieldValue.trim());
    handleCloseModal();
  };

  return (
    <DillModal
      open={open}
      onClose={handleCloseModal}
      title={title}
      footer={
        <>
          <DillButton label="Cancel" variant="secondary" onClick={handleCloseModal} />
          <DillButton label="Submit" onClick={handleSubmit} />
        </>
      }>
      <AppInputField
        isRequired
        label="Enter your email for confirmation"
        inputType="email"
        errorText={error}
        value={textFieldValue}
        onTextChange={(text) => {
          setTextFieldValue(text);
          setError('');
        }}
      />
    </DillModal>
  );
};
